import { AlertTriangle, PlayCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NoCourierAlert({ orders, info, onPause, onSelectCall }) {
  const stuck = orders.filter((o) => o.dispatch?.status === "no_courier" && ["confirmado", "preparo", "pronto"].includes(o.status));
  if (!info.module) return null;
  if (!info.menu_enabled) {
    return (
      <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-800 dark:text-amber-200" data-testid="menu-paused-alert">
        <AlertTriangle className="h-4 w-4 shrink-0" /><span className="flex-1">As vendas do cardápio digital estão bloqueadas.</span>
        <Button size="sm" variant="outline" onClick={() => onPause(true)} data-testid="menu-resume-btn"><PlayCircle className="mr-1 h-4 w-4" />Liberar vendas</Button>
      </div>
    );
  }
  if (!stuck.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-700 dark:text-red-300" data-testid="no-courier-alert">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="flex-1">Sem entregador para {stuck.length === 1 ? "o pedido" : "os pedidos"} {stuck.map((o) => `#${o.number}`).join(", ")}. Quer bloquear as vendas do cardápio até ter entregador?</span>
      <Button size="sm" variant="outline" onClick={() => onSelectCall(stuck[0])} data-testid="no-courier-call-btn">Chamar de novo</Button>
      <Button size="sm" variant="destructive" onClick={() => onPause(false)} data-testid="no-courier-pause-btn">Bloquear vendas</Button>
    </div>
  );
}
